import React, { Component } from 'react'
import styles from '../style.module.less'
// import indexStore from '../Tabs/store'
// import store from '../SetConsultGift/store'
import { observer } from 'mobx-react'
import ModalIf from '@common/ModalIf'
import mainStore from '@components/Main/store'
import myStore from './store'
import { PRIVILEGE_CONSULT_GIFT } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    myStore.getGift(PRIVILEGE_CONSULT_GIFT)
  }

  render() {
    const {
      gift_status,
      gift_content,
      gift_reason,
      giftModal,
      onCancelGift
    } = myStore

    const {
      merchantInfo: { is_special_merchant }
    } = mainStore

    return (
      <div className={styles.brief}>
        {(is_special_merchant == 1 || is_special_merchant == 2) && (
          <p style={{ marginBottom: 10, fontSize: 14 }}>
            <i className={styles.attention}>i</i>
            {is_special_merchant == 1 && (
              <span>您的设置和修改将同步至所有的店铺，子店铺无法修改</span>
            )}
            {is_special_merchant == 2 && (
              <span>
                您无法修改当前设置，系统将默认认为您同步主门店的相关设置
              </span>
            )}
          </p>
        )}

        {(gift_status == 3 || gift_status == 4) &&
          is_special_merchant != 2 && (
            <div className={styles.pendingMsg}>
              <img src="http://qnm.hunliji.com/o_1b3c9uqm9am31qpf1rd9qr1c437.png" />
              {gift_status == 3 && (
                <span>审核中！在审核结束后，您将收到我们的通知</span>
              )}
              {gift_status == 4 && <span>{gift_reason}</span>}
            </div>
          )}
        {gift_status != 0 && (
          <div className={styles.modify}>
            咨询礼：{gift_content}
            {gift_status == 2 &&
              is_special_merchant != 2 && (
                <a
                  className={styles.btnPrimary}
                  href="#/localMerchant/marketingTools/setConsultGift"
                >
                  开启
                </a>
              )}
            {gift_status != 0 &&
              gift_status != 2 &&
              is_special_merchant != 2 && (
                <div style={{ float: 'right' }}>
                  <span
                    className={styles.btnDefault}
                    onClick={myStore.closeConsultGift}
                  >
                    关闭
                  </span>
                  <a
                    className={styles.btnPrimary}
                    href="#/localMerchant/marketingTools/setConsultGift"
                  >
                    修改
                  </a>
                </div>
              )}
          </div>
        )}
        {(gift_status == 0 || gift_status == 2) && (
          <div className={styles.introduction}>
            {/* <img src="http://qnm.hunliji.com/o_1aaggsme8935vg1qbg1t5k1ovtn.jpg" />
            <img src="http://qnm.hunliji.com/o_1aaggsme81bjmubdaml1hnd16gbo.jpg" />
            <img src="http://qnm.hunliji.com/o_1aagiid3l1a4hu5f1osh1lfe11ac7.jpg" /> */}
            <div>
              <img
                style={{ width: 780 }}
                src="//qnm.hunliji.com/o_1cjsaiun51v51c16eugt7ggcq7.jpg"
              />
            </div>

            {/* <div>
              <img src="http://qnm.hunliji.com/o_1aaggniqu10m81tmd113t19gae5ub.jpg" />
            </div> */}
            {gift_status == 0 &&
              is_special_merchant != 2 && (
                <span onClick={myStore.openConsultGift}>立即开通</span>
              )}
          </div>
        )}
        <ModalIf
          type={giftModal.type}
          isShow={giftModal.isShow}
          content={giftModal.content}
          btn1={giftModal.btn1}
          btn2={giftModal.btn2}
          hrefVal={giftModal.hrefVal}
          onClick={onCancelGift}
        />
      </div>
    )
  }
}
